import React from 'react'
import Transition from '../components/Transition'

const Layout = ({ children, location }) => {
  return <Transition location={location}>{children}</Transition>
}

export default Layout
